import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomeComponent } from "src/app/pages/home/home.component";
import { CatalogComponent } from "src/app/pages/catalog/catalog.component";
import { ProductComponent } from "src/app/pages/product/product.component";
import { ContactComponent } from "./pages/contact/contact.component";
import { CartComponent } from "./pages/cart/cart.component";
import { ConfirmationComponent } from "./pages/orders/confirmation/confirmation.component";
import { OrdersComponent } from "./pages/orders/orders/orders.component";
import { PageNotfoundComponent } from "./pages/page-notfound/page-notfound.component";
import { CheckoutComponent } from "./pages/checkout/checkout.component";
import { SummaryComponent } from "./pages/orders/summary/summary.component";
// import { ReviewartworkComponent } from "./pages/orders/reviewartwork/reviewartwork.component";
import { QuickorderComponent } from "./pages/quickorder/quickorder.component";
import { UsesComponent } from "./pages/uses/uses.component";
import { CmspagesComponent } from "./pages/cmspages/cmspages.component";
import { AdminloginComponent } from "./pages/adminlogin/adminlogin.component";
import { MaintenancePageComponent } from "./pages/maintenance-page/maintenance-page.component";
import { PaymentGenericComponent } from "./pages/payment-generic/payment-generic.component";
import { AddressBookComponent } from "./pages/address-book/address-book.component";
import { ProductTShirtComponent } from "./pages/product-t-shirt/product-t-shirt.component";
import { ElectionTShirtComponent } from "./pages/election-t-shirt/election-t-shirt.component";
import { FilesComponent } from "./pages/files/files.component";
import { WalletComponent } from "./pages/wallet/wallet.component";


const routes: Routes = [
  { path: "", component: HomeComponent },
  { path: "server/maintenance", component: MaintenancePageComponent },
  { path: "catalog", component: CatalogComponent },
  { path: "contact-us", component: ContactComponent },
  { path: "quickorder", component: QuickorderComponent },
  /* { path : 'uses', component: UsesComponent}, */
  { path: "samples", component: UsesComponent },
  { path: "order/:orderId/confirmation", component: ConfirmationComponent },
  { path: "cms/:page", component: CmspagesComponent },
  { path: "cart", component: CartComponent },
  { path: "checkout", component: CheckoutComponent },
  { path: "adminlogin/:token", component: AdminloginComponent },
  { path: "adminlogin/:token/:redirectpath", component: AdminloginComponent },
  { path: "my/orders", component: OrdersComponent },
  { path: 'my/orders/:page', component: OrdersComponent},
  { path: "my/order/:orderId/confirmation", component: ConfirmationComponent },
  { path: "my/order/confirmation/thankyou/:orderId", component: ConfirmationComponent },
  { path: "my/order/:orderId/summary", component: SummaryComponent },
  { path: "my/address-book", component: AddressBookComponent },
  { path: "my/files", component: FilesComponent },
  { path: "my/wallet", component: WalletComponent },
  { path: "payment/:orderIncrementId", component: PaymentGenericComponent },
//   { path: "my/order/:orderId/review/:quoteItemId", component: ReviewartworkComponent,},
  { path: "t-shirt/custom-t-shirt.html", component: ProductTShirtComponent },
  { path: "t-shirt/election-t-shirt.html", component: ElectionTShirtComponent },
  { path: "bag/custom-canvas-tote-bag.html", component: ProductTShirtComponent },
  // { path: "matte-sticker.html/:reviewrequest", component: ProductComponent },
  { path: ":prouctlink", component: ProductComponent },
  { path: "**", component: PageNotfoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
